{
  "profile": {
    "dateOfBirth": "Data nașterii",
    "phone": "Telefon",
    "emergencyContactName": "Numele persoanei de contact de urgență",
    "emergencyContactPhone": "Telefonul persoanei de contact de urgență",
    "relationship": "Relație",
    "medicalNotes": "Note medicale"
  }
}
